module.exports = __webpack_public_path__ + "static/media/mobile5.6c346a90.png";